import { useList } from "effector-react"

import globalAssetOverviewAssetSidebars from "stores/globalAssetOverviewAssetSidebars"
import useLocationChange from "hooks/useLocationChange"
import GlobalAssetOverviewAssetSidebar, { IGlobalAssetOverviewAssetSidebarProps } from "components/GlobalAssetOverviewAssetSidebar/GlobalAssetOverviewAssetSidebar"

const GlobalAssetOverviewAssetSidebars = () => {
    useLocationChange(globalAssetOverviewAssetSidebars.clear)

    async function handleClose(props: IGlobalAssetOverviewAssetSidebarProps) {
        props.onClose?.()
        globalAssetOverviewAssetSidebars.hide(props)
    }

    return (
        <>
            {useList(globalAssetOverviewAssetSidebars.list, (props: IGlobalAssetOverviewAssetSidebarProps, idx) => (
                <GlobalAssetOverviewAssetSidebar
                    key={idx}
                    {...props}
                    onClose={() => handleClose(props)}
                />
            ))}
        </>
    )
}

export default GlobalAssetOverviewAssetSidebars
